<app-page-header [title]="pageTitle" [breadcrumbs]="breadcrumb"></app-page-header>

<section class="content">
    <div class="container-fluid">
        <div class="col-lg-12">

            <mat-card class="organisation">
                <mat-card-header class="loading-header" [ngClass]="{ loading: loading }">
                    <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
                </mat-card-header>

                <mat-tab-group>
                    <mat-tab label="Organisation">
                        <ng-template matTabContent>

                            <app-organisation-form 
                                [organisation]="organisation" 
                                [loading]="loading"
                                [saveLoading]="orgSaveLoading"
                                (submitForm)="updateOrganisation($event)"
                            ></app-organisation-form>

                        </ng-template>
                    </mat-tab>
                    <mat-tab label="Platform">
                        <ng-template matTabContent>
                            <app-platform-form 
                                [platform]="platform" 
                                [loading]="loading"
                                (submitForm)="updatePlatform($event)"
                            ></app-platform-form>
                        </ng-template>
                    </mat-tab>

                    <mat-tab label="Call to actions">
                        <ng-template matTabContent>
                            <app-cta-form 
                                [welcomePage]="platform?.welcomePage" 
                                [loading]="loading"
                                (submitForm)="updateWelcomePage($event)"
                            ></app-cta-form>
                        </ng-template>
                    </mat-tab>

                    <mat-tab label="Reports">
                        <ng-template matTabContent>
                            <app-reports-form 
                            [organisationTag]="organisation.tag" 
                            ></app-reports-form>
                        </ng-template>
                    </mat-tab>

                    <mat-tab label="Reimbursements">
                        <ng-template matTabContent>
                            <app-reimbursements-form 
                            [countryTag]="organisation.countryTag"
                            ></app-reimbursements-form>
                        </ng-template>
                    </mat-tab>
                </mat-tab-group>

            </mat-card>

        </div>
    </div>
</section>